import { gql } from '@apollo/client'

export default gql(`
query listMediaCategories($project: String){
    listMediaCategories(project: $project){
            id
            type
            label
            isActive
    }
}`)
